// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation SendAiMessageMutation($input: SendAiMessageInput!) {
    sendAiMessage(input: $input) {
      aiMessage {
        messageId
        conversationId
        role
        content
        tokensUsed
        createdAt
      }
      conversationId
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
